<template>
  <div class="c-box">
    <div class="box-inner">
      <!-- [20241206] 개인정보처리방침수정 -->
      <div class="c-terms">
        <strong class="subject"
          >(주)노루페인트 페인트 프로(구 사이버샵) 홈페이지 개인정보(Privacy
          Policy) 취급방침</strong
        >
        <p class="text">
          (주)노루페인트는 모든 인터넷 사용자의 개인정보 보호 문제를 매우
          중요하게 생각하고 있으며 정보통신부에서 정한 개인정보보호지침 중
          아래의 내용을 엄격히 준수하고 있습니다.
        </p>
        <ul class="list">
          <li>■ 개인정보의 처리 목적, 처리 및 보유기간</li>
          <li>■ 개인정보의 보유 및 폐기</li>
          <li>■ 개인정보 처리의 위탁에 관한 사항</li>
          <li>
            ■ 정보주체와 법정대리인의 권리, 의무 및 그 행사방법에 관한 사항
          </li>
          <li>■ 쿠키(cookie)의 운용 및 활용</li>
          <li>■ 기술적/관리적 대책</li>
          <li>■ 개인정보 관리 책임자</li>
          <li>■ 개인정보에 관한 민원서비스</li>
        </ul>

        <strong class="subject">개인정보의 처리 목적, 처리 및 보유기간</strong>
        <p class="text">
          (주)노루페인트는 사용자의 동의 없이 개인정보를 수집하지 않으며, 수집한
          개인정보를 다음의 목적을 위해 활용합니다.
        </p>
        <p class="text">
          1) 고객관리 및 서비스 제공 : 홈페이지 회원관리, 고객 문의사항 응대,
          서비스 변경사항 및 고지사항 전달, 배송관련, 매입정보, 유해물질
          법적준수사항, 애니칼라시스템, 원격지원서비스등
          <em class="is-highlight">페인트 프로</em> 구성내의 필요한 정보제공시
          수반사항
        </p>
        <p class="text">
          2) 통계학적 특성에 따른 서비스 개발 및 맞춤 서비스 제공 : 서비스 개발
          및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재,
          이벤트 및 광고성 정보 제공 및 참여 기회 제공, 접속 빈도 파악, 회원의
          서비스 이용에 대한 통계
        </p>

        <div class="c-table type-line type-small">
          <table>
            <caption>
              개인정보의 처리 목적, 처리 및 보유기간 테이블
            </caption>
            <colgroup>
              <col style="width: 28%" />
              <col />
              <col style="width: 24%" />
            </colgroup>
            <thead>
              <tr>
                <th>수집목적</th>
                <th>수집항목</th>
                <th>보유/이용기간</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>홈페이지 회원관리</td>
                <td>이름(특약점명), 아이디, 비밀번호, 핸드폰번호</td>
                <td>회원 탈퇴시까지</td>
              </tr>
              <tr>
                <td>고객 문의사항 응대</td>
                <td>이름(특약점명), 아이디, 이메일주소, 주소(선택)</td>
                <td>회원 탈퇴시까지</td>
              </tr>
              <tr>
                <td class="is-highlight">조색 배합 시스템</td>
                <td>이름(특약점명), 핸드폰번호, 주소, 이메일</td>
                <td>회원 탈퇴시까지</td>
              </tr>
              <tr>
                <td>배송관련 서비스 변경사항 및 고지사항 전달</td>
                <td>이름(특약점명), 핸드폰번호, 주소,카카오서비스,연락처</td>
                <td>회원 탈퇴시까지</td>
              </tr>
              <tr>
                <td>원격서비스</td>
                <td>이름(특약점명), 핸드폰번호, 이메일주소</td>
                <td>회원 탈퇴시까지</td>
              </tr>
              <tr>
                <td>취급유해물질 및 법적규제관련 서비스</td>
                <td>이름(특약점명), 핸드폰번호, 이메일주소</td>
                <td>회원 탈퇴시까지</td>
              </tr>
            </tbody>
          </table>
        </div>

        <strong class="subject">개인정보의 보유 및 폐기</strong>
        <p class="text">
          이용자가 (주)노루페인트의 회원으로서 (주)노루페인트가 제공하는
          서비스를 받는 동안 회원님의 개인정보는 (주)노루페인트에서 일정기간
          저장/보유하며 서비스 제공을 위해 이용하게 됩니다. 다만 회원께서 탈퇴를
          하시거나 이용약관 제7조에 의한 회원 자격 상실의 경우에는 수집된 개인의
          정보는 재생할 수 없는 방법에 의하여 하드디스크에서 완전히 삭제되며
          어떠한 용도로도 열람 또는 이용할 수 없도록 처리됩니다. 전자적
          파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을
          사용하여 삭제합니다.
        </p>

        <strong class="subject">개인정보 처리의 위탁에 관한 사항</strong>
        <p class="text">
          (주)노루페인트는 서비스 향상을 위해서 아래와 같이 개인정보 처리를
          위탁하고 있으며, 관계 법령에 따라 위탁계약 시 개인정보가 안전하게
          관리될 수 있도록 필요한 사항을 규정하고 있습니다.
        </p>
        <p class="text">
          (주)노루페인트
          <em class="is-highlight">페인트 프로</em> 홈페이지의 개인정보 처리위탁
          기관 및 위탁업무 내용은 아래와 같습니다.
        </p>
        <ul class="list">
          <li>수탁자 : <b>(주)디아이티</b></li>
          <li>위탁업무 내용 : 웹사이트 및 시스템 관리</li>
          <li>위탁기간 : 2006. 1. 2 ~ 2025. 12. 31</li>
        </ul>
        <p class="text">
          위탁업무의 내용이나 수탁자가 변경될 경우에는 지체 없이 본 개인정보
          처리방침을 통하여 공개하도록 하겠습니다.
        </p>

        <strong class="subject"
          >정보주체와 법정대리인의 권리, 의무 및 그 행사방법에 관한 사항</strong
        >
        <ul class="list">
          <li>
            ① 이용자 및 법정대리인은 언제든지 등록되어 있는 자신 혹은 당해 만
            14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며,
            (주)노루페인트의 개인정보의 처리에 동의하지 않는 경우 동의를
            거부하거나 가입 해지(회원탈퇴)를 요청하실 수 있습니다. 다만, 그러한
            경우 서비스의 일부 또는 전부의 이용이 어려울 수 있습니다.
          </li>
          <li>
            ② 이용자 혹은 만 14세 미만 아동의 개인정보 조회, 수정을 위해서는
            '개인정보변경'(또는 '회원정보수정' 등)을, 가입 해지(동의철회)를
            위해서는 개인정보 보호책임자 또는 개인정보 보호담당자에게 연락하시면
            지체 없이 조치하겠습니다.
          </li>
          <li>
            ③ 이용자가 개인정보의 오류에 대한 정정을 요청한 경우에는 정정을
            완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한
            잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를
            제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.
          </li>
          <li>
            ④ ㈜노루페인트는 이용자 혹은 법정대리인의 요청에 의해 해지 또는
            삭제된 개인정보를 "개인정보의 보유 및 이용기간"에 명시된 바에 따라
            처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고
            있습니다.
          </li>
        </ul>

        <strong class="subject">쿠키의 운영 및 활용</strong>
        <p class="text is-highlight">
          (주)노루페인트는 웹사이트의 기능 향상, 사용자 경험 개선, 맞춤형 서비스
          제공 등의 목적을 위해 쿠키(cookie)를 사용합니다.
        </p>

        <strong class="subject">기술적/관리적 대책</strong>
        <p class="text">
          (주)노루페인트는 개인정보보호를 위하여 관리자를 한정하여 그 수를
          최소화하며 회원 개인정보의 분실, 도난, 유출, 변조 등으로 인한 이용자의
          손해에 대하여 모든 책임을 집니다.
        </p>
        <p class="text">
          (주)노루페인트는 귀하의 개인정보를 취급함에 있어 개인정보가 분실,
          도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은
          기술적 대책을 강구하고 있습니다.
        </p>
        <ul class="list">
          <li>
            ① 회원의 개인정보는 비밀번호에 의해 보호되며, 파일 및 전송 데이터를
            암호화하거나 파일 잠금기능(Lock)을 사용하여 중요한 데이터는 별도의
            보안기능을 통해 보호되고 있습니다.
          </li>
          <li>
            ② (주)노루페인트는 백신프로그램을 이용하여 컴퓨터바이러스에 의한
            피해를 방지하기 위한 조치를 취하고 있습니다. 백신프로그램은
            주기적으로 업데이트되며 갑작스런 바이러스가 출현할 경우 백신이
            나오는 즉시 이를 제공함으로써 개인정보가 침해되는 것을 방지하고
            있습니다.
          </li>
          <li>
            ③ (주)노루페인트는 암호알고리즘을 이용하여 네트워크 상의 개인정보를
            안전하게 전송할 수 있는 보안장치(SSL 또는 SET)를 채택하고 있습니다.
          </li>
          <li>
            ④ 해킹 등에 의해 귀하의 개인정보가 유출되는 것을 방지하기 위해,
            외부로부터의 침입을 차단하는 장치를 이용하고 있으며, 각 서버마다
            침입탐지시스템을 설치하여 24 시간 침입을 감시하고 있습니다.
          </li>
        </ul>

        <strong class="subject">개인정보 보호 담당자 및 책임자</strong>
        <p class="text">
          (주)노루페인트는 고객님의 개인정보를 보호하고, 개인정보와 관련된
          불만을 처리하기 위하여 아래와 같이 담당 부서 및 보호책임자를 지정하고
          있습니다.
        </p>
        <div class="col-list-box">
          <div class="item">
            <ul>
              <li>개인정보 보호 책임자</li>
              <li>이름 : 하성욱</li>
              <li>소속 : 시장운영팀</li>
              <li>직위 : 팀장</li>
              <li>전화 : 031)467-6413</li>
            </ul>
          </div>
          <div class="item">
            <ul>
              <li>개인정보 보호 담당자</li>
              <li>이름 : 박재현</li>
              <li>소속 : 시장운영팀</li>
              <li>직위 : 대리</li>
              <li>전화 : 031)467-6451</li>
            </ul>
          </div>
          <div class="item">
            <ul>
              <li>개인정보 보호 담당자</li>
              <li>이름 : 박진태</li>
              <li>소속 : DIT</li>
              <li>직위 : 프로</li>
              <li>전화 : 031)360-3815</li>
            </ul>
          </div>
        </div>

        <strong class="subject">개인정보에 관한 민원서비스</strong>
        <div class="c-table type-small">
          <table>
            <caption>
              개인정보에 관한 민원서비스 테이블
            </caption>
            <colgroup>
              <col style="" />
              <col style="width: 43.825%" />
              <col style="width: 23.904%" />
            </colgroup>
            <thead>
              <tr>
                <th>기관명</th>
                <th>홈페이지</th>
                <th>연락처</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>경찰청 사이버안전국</td>
                <td>http://cyberbureau.police.go.kr</td>
                <td>(국번없이) 182</td>
              </tr>
              <tr>
                <td>대검찰청 사이버수사과</td>
                <td>http://www.spo.go.kr</td>
                <td>(국번없이) 1301</td>
              </tr>
              <tr>
                <td>개인정보 침해신고센터 (한국인터넷 진흥원 운영)</td>
                <td>http://privacy.kisa.or.kr</td>
                <td>(국번없이) 118</td>
              </tr>
              <tr>
                <td>개인정보 분쟁조정위원회 (개인정보보호위원회 운영)</td>
                <td>http://www.kopico.go.kr</td>
                <td>1833-6972</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="text is-highlight">
          본 개인정보취급방침은 2025년 04월 1일부터 시행됩니다.
        </p>
      </div>
      <!-- // [20241206] 개인정보처리방침수정 -->
    </div>
  </div>
</template>

<script setup></script>
